/* eslint-disable max-len */

export default {
  401: 'Your account is missing a permission required to perform this action. Please contact your administrator.',
  500: 'A server error has occurred. Please contact your administrator if the issue persists.',
  DEFAULT:
    'An unknown error has occurred. Please contact your administrator if the issue persists.',
};
